import { render, staticRenderFns } from "./AllGoodsList.vue?vue&type=template&id=da8bf3d2&scoped=true&"
import script from "./AllGoodsList.vue?vue&type=script&lang=js&"
export * from "./AllGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./AllGoodsList.vue?vue&type=style&index=0&id=da8bf3d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8bf3d2",
  null
  
)

export default component.exports